var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatBubbleOvalLeft = function SvgChatBubbleOvalLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.6 8c0-3.173 2.952-5.6 6.4-5.6s6.4 2.427 6.4 5.6-2.952 5.6-6.4 5.6a7.3 7.3 0 0 1-1.203-.099 4.78 4.78 0 0 1-3.148.886.6.6 0 0 1-.467-.914c.254-.41.405-.89.417-1.405C2.383 11.06 1.6 9.62 1.6 8Z",
    clipRule: "evenodd"
  })));
};
export { SvgChatBubbleOvalLeft as ReactComponent };
export default __webpack_public_path__ + "9ee148a189d16991b9cf61fde9eeb0af.svg";